import React, { useState, useEffect, useRef } from "react";
import ApplicationLayout from "../../../layouts/ApplicationLayout";
import { Helmet } from "react-helmet";
import { useSelector } from "react-redux";
import { IAM_API_BASE_URL_2 } from "../../../services/TapApiUrls";
import HttpAPICall from "../../../services/HttpAPICall";
import PageHeader from "../../includes/PageHeader";
import TapIcon from "../../../services/TapIcon";
import { DisplayListPagination } from "../../../components/TapUi";
import Loader from "../../../components/ui/Loader/Loader";
import DownloadFile from "../../../services/DownloadFile";

const RcaReport = (props) => {

    const rcaUrl                                    =       IAM_API_BASE_URL_2 + "/ticket/rca_list";
    const access_token                              =       useSelector(state => state.auth.access_token);
    const [listing_loading, setListing_loading]     =       useState(false)
    const [rcaDownloading, setRcaDownloading]       =       useState(false)
    const [listingMeta, setListingMeta]             =       useState(null)
    const [rcaData, setRcaData]                     =       useState([])

    useEffect(() => {
        fetchRCAData();
    }, []);

    const closeReport           =       ()            => {
        props.history.push('/report');
    }

    const fetchRCAData          =       ()            => {
        setListing_loading(true)
        HttpAPICall.withAthorization('GET', rcaUrl, access_token, {}, {}, (resp) => {
            if (resp.data) {
                setRcaData(resp.data.data)
                setListingMeta({
                    from: resp.data.from,
                    to: resp.data.to,
                    total: resp.data.total,
                    last_page: resp.data.last_page,
                    per_page: resp.data.per_page,
                    current_page: resp.data.current_page
                })
            }
            setListing_loading(false)
        });
    };

    const reportDownloadHandler =       ()            => {
        setRcaDownloading(true)
        HttpAPICall.withAthorization('GET', rcaUrl, access_token, { action: "download" }, {}, (response) => {
            DownloadFile.file(null,response.data.msg,response.data.navigation,props)
        })
            .then(() => setRcaDownloading(false));
    }

    const topRightHeaderJsx     =       ()            => {
        return <>
            <button type="button" disabled={listing_loading || rcaDownloading} className="btn btn-secondary" onClick={reportDownloadHandler}>
                <TapIcon.FontAwesomeIcon icon={TapIcon.faDownload} />
                {rcaDownloading && <TapIcon.FontAwesomeIcon icon={TapIcon.faSyncAlt} className="fa-spin ms-2" />}
            </button>
            <button type="button" disabled={listing_loading} className="btn btn-secondary mx-1" onClick={closeReport}>
                <TapIcon.imageIcon icon={TapIcon.CloseIcon} className="img-fluid" alt="Close requisition" />
            </button>
        </>
    }

    const pageHeading           =       ()            => {
        return <PageHeader title="Root Cause Analysis Report" name="Root Cause Analysis Report" rightTopHeadingJsx={topRightHeaderJsx()} />
    }

    const rcaTable              =       ()            => {
        const maxPoints = rcaData.reduce((max, item) =>
            Math.max(max, item.rca_data?.length || 0), 0);
        const pointColWidth = `${100 / (4 + maxPoints * 3)}%`;

        return (<>
            <div className="table-responsive" style={{ overflowX: "auto" }}>
                <table className="table table-sm table-bordered align-middle bg-white">
                    <thead className="align-middle table-secondary">
                        <tr className='text-center'>
                            <th style={{ width: "5%", minWidth: "50px" }}>S.No</th>
                            <th style={{ width: "15%", minWidth: "150px" }}>Ticket ID</th>
                            <th style={{ width: "15%", minWidth: "150px" }}>Ticket Type</th>
                            <th style={{ width: "15%", minWidth: "150px" }}>Header</th>
                            {[...Array(Math.max(1, Math.min(maxPoints, 5)))].map((_, i) => (
                                <React.Fragment key={i}>
                                    <th style={{ width: pointColWidth, minWidth: "200px" }}>Point {i + 1}</th>
                                    <th style={{ width: pointColWidth, minWidth: "200px" }}>Analysis {i + 1}</th>
                                    <th style={{ width: pointColWidth, minWidth: "200px" }}>Cause {i + 1}</th>
                                </React.Fragment>
                            ))}
                            <th style={{ width: "20%", minWidth: "200px" }}>Final Conclusion</th>
                            <th style={{ width: "20%", minWidth: "200px" }}>Action Plan</th>
                        </tr>
                    </thead>
                    <tbody>
                        {listing_loading ? (
                            <tr><td colSpan={6 + maxPoints * 3}><Loader /></td></tr>
                        ) : rcaData.length > 0 ? (
                            rcaData.map((item, index) => {
                                const details = item.rca_data || [];
                                return (
                                    <tr key={index}>
                                        <td className='text-center'>
                                            {listingMeta ? listingMeta.from + index : index}</td>
                                        <td className='text-center'>{item.ticket_id || "-"}</td>
                                        <td className='text-center'>{item.ticket_type || "-"}</td>
                                        <td className='text-center'>{item.header || "-"}</td>
                                        {[...Array(Math.max(1, Math.min(maxPoints, 5)))].map((_, i) => {
                                            const detail = details[i] || {};
                                            return (
                                                <React.Fragment key={i}>
                                                    <td className='text-center'>{detail.point || "-"}</td>
                                                    <td className='text-center'>{detail.reason || "-"}</td>
                                                    <td className='text-center'>{detail.cause || "-"}</td>
                                                </React.Fragment>
                                            );
                                        })}
                                         <td className="text-center" dangerouslySetInnerHTML={{ __html: item.final_conclusion }} />
                                         <td className="text-center" dangerouslySetInnerHTML={{ __html: item.action_plan }} />
                                    </tr>
                                );
                            })
                        ) : (
                            <tr className="text-center"><td colSpan={6 + maxPoints * 3}>No records found</td></tr>
                        )}
                    </tbody>
                </table>
            </div>
            <DisplayListPagination
                meta={listingMeta}
                onPageChange={(e) => fetchRCAData(e.selected + 1)}
            />
        </>
        );
    };

    return (
        <>
            <ApplicationLayout>
                {pageHeading()}
                <Helmet><title>Root Cause Analysis - Report</title></Helmet>
                <div className="container-fluid pl5">
                    <div className="page_containt row">
                        <div id="pageTbl" className=" pageTbl col-12 pb-2">
                            {rcaTable()}
                        </div>
                    </div>
                </div>
            </ApplicationLayout>
        </>
    );
};

export default RcaReport;